import React, { useEffect, useState } from "react";
import "../../css_files/Master/SearchUnitMaster.css";
import CloseForm from "./CloseForm";
import axiosInstance from "../../api";
import Select from "react-select";

function SearchUnitMaster({
  setshowsearchform,
  setIds,
  setUnitId,
  setpagenumber,
  setReload,
  setSearch,
  reload,
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Unit/GetUnitDropdown`)
      .then((res) => {
        setOptions(res.data);
      })
      .catch(console.log);
  }, []);
  return (
    <div className="search-unit-master-form">
      <h3>Search Unit Master By Entering at least One Field</h3>
      <blockquote>
        <label>Id</label>
        <input
          type="number"
          placeholder="Enter Unit Master Id (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setUnitId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setUnitId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>
      <blockquote>
        <label>Name</label>
        <Select
          isSearchable
          options={options}
          onChange={(values) => {
            if (values) setIds(values.map((x) => x.value));
          }}
          isMulti
          isClearable
          placeholder="Select Name"
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          menuPlacement="top"
          styles={{
            container: (base) => ({
              ...base,
              width: "100%",
            }),
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
            control: (base, state) => ({
              ...base,
              borderColor: "black",
              "&:hover": {
                borderColor: "black",
              },
              boxShadow: "none",
            }),
            singleValue: (base) => ({
              ...base,
              color: "black",
            }),
            dropdownIndicator: (base) => ({
              ...base,
              color: "black",
              "&:hover": {
                color: "black",
              },
            }),
            indicatorSeparator: (base) => ({
              ...base,
              backgroundColor: "black",
            }),
            noOptionsMessage: (base) => ({
              ...base,
              color: "black",
            }),
          }}
        />
      </blockquote>

      <blockquote>
        <label>Search</label>
        <input
          type="search"
          placeholder="Enter Search Keyword (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>

      <CloseForm
        close={(x) => {
          setshowsearchform(x);
          setIds([]);
          setUnitId(null);
          setSearch("");
          setReload(!reload);
        }}
      />
    </div>
  );
}

export default SearchUnitMaster;
